// isChrome
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('chrome') !== -1;
})();
